import {
  ConditionDataType,
  ConditionType,
} from 'src/targeting/conditions/types';
import { Result } from 'ts-res';
import { KameleoonError } from 'src/kameleoonError';

export interface IConditionFactory {
  createCondition(
    data: ConditionDataType,
  ): Result<ConditionType, KameleoonError>;
}

export class ConditionFactoryInstance {
  static conditionFactoryInstance: IConditionFactory;

  static setConditionFactoryInstance(value: IConditionFactory): void {
    this.conditionFactoryInstance = value;
  }

  static createCondition(
    data: ConditionDataType,
  ): Result<ConditionType, KameleoonError> {
    return this.conditionFactoryInstance.createCondition(data);
  }
}
